export default __webpack_public_path__ + "static/media/img_demo_03_m.3cda62e0.webp";